<template>
   <div class="input-group">
      <input class="form-control"
        @input="handleInput"
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        :placeholder="placeholder" 
        autocomplete="current-password"/>
      <button 
        type="button"
        class="btn btn-outline-secondary"
        :class="{'cursor-pointer':showPointer}"
        @click="showPassword = !showPassword"
        @mouseout="showPointer = false"
        @mouseover="showPointer = true">
        <fa-icon :name="showPassword ? 'eye-slash' : 'eye'" />
      </button>
  </div>
</template>
<script>
export default {
  name: 'PasswordInput',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      showPassword: false,
      showPointer: false,
      password: this.modelValue
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal !== this.password) {
        this.password = newVal;
      }
    }
  },
  methods: {
    handleInput() {
      this.$emit('update:modelValue', this.password)
    }
  }
}
</script>
